export enum smeType {
	Production = 1,
	Reviewer = 2
}

export const smeLabels: SmeLabel[] = [
	{
		label: "Production",
		smeType: smeType.Production
	},
	{
		label: "Reviewer",
		smeType: smeType.Reviewer
	}
]

export interface SmeLabel {
	label: string,
	smeType: smeType
}
